import { GET_MY } from '../../containers/App/constants';
import {
  WEBLOGIN_FETCH_VEHICLES,
  WEBLOGIN_FETCH_VEHICLE,
  WEBLOGIN_FETCH_VEHICLE_BUYING_CONTACT,
  WEBLOGIN_FETCH_VEHICLE_INVOICES,
  WEBLOGIN_FETCH_VEHICLE_INVOICE,
  WEBLOGIN_REQUSET_ADD_DOCUMENT,
} from './constants';
import { REQUEST_VEHICLE_DOCUMENTS_BY_TYPE } from '../Vehicles/constants';

export function fetchWebloginVehicles(filter) {
  return {
    type: GET_MY,
    work: WEBLOGIN_FETCH_VEHICLES,
    gate: WEBLOGIN_FETCH_VEHICLES,
    id: WEBLOGIN_FETCH_VEHICLES,
    post: {
      filter,
    },
    path: `customer/vehicles`,
  };
}

export function fetchWebloginVehicle(vehicleId) {
  return {
    type: GET_MY,
    vehicleId,
    gate: `${WEBLOGIN_FETCH_VEHICLE}-${vehicleId}`,
    work: `${WEBLOGIN_FETCH_VEHICLE}-${vehicleId}`,
    id: WEBLOGIN_FETCH_VEHICLE,
    path: `customer/vehicles/${vehicleId}`,
  };
}

export function fetchWebloginVehicleBuyingContact(vehicleId, callback) {
  return {
    type: GET_MY,
    vehicleId,
    gate: `${WEBLOGIN_FETCH_VEHICLE_BUYING_CONTACT}-${vehicleId}`,
    work: `${WEBLOGIN_FETCH_VEHICLE_BUYING_CONTACT}-${vehicleId}`,
    id: WEBLOGIN_FETCH_VEHICLE_BUYING_CONTACT,
    path: `customer/vehicles/${vehicleId}/buying-contact`,
    callback,
  };
}

export function fetchWebloginVehicleInvoices(vehicleId) {
  return {
    type: GET_MY,
    gate: `${WEBLOGIN_FETCH_VEHICLE_INVOICES}-${vehicleId}`,
    work: `${WEBLOGIN_FETCH_VEHICLE_INVOICES}-${vehicleId}`,
    id: WEBLOGIN_FETCH_VEHICLE_INVOICES,
    path: `customer/vehicles/${vehicleId}/invoices`,
  };
}

export function fetchWebloginVehicleInvoice(vehicleId, invoiceId, callback) {
  return {
    type: GET_MY,
    vehicleId,
    gate: `${WEBLOGIN_FETCH_VEHICLE_INVOICE}-${vehicleId}`,
    work: `${WEBLOGIN_FETCH_VEHICLE_INVOICE}-${vehicleId}`,
    id: WEBLOGIN_FETCH_VEHICLE_INVOICE,
    path: `customer/vehicles/${vehicleId}/invoices/${invoiceId}`,
    callback,
  };
}

export function addWebloginDocument(vehicleId, documentDto, callback, work) {
  work = work ? [work] : [];
  work.push(WEBLOGIN_REQUSET_ADD_DOCUMENT);

  return {
    type: GET_MY,
    work,
    gate: WEBLOGIN_REQUSET_ADD_DOCUMENT + vehicleId,
    post: documentDto,
    options: { formData: true },
    path: `/customer/vehicles/${vehicleId}/document`,
    putOnComplete: [fetchWebloginVehicle(vehicleId)],
    callback,
  };
}

export function getDocumentsWebloginByType(vehicleId, documentType, callback) {
  return {
    type: GET_MY,
    work: `${REQUEST_VEHICLE_DOCUMENTS_BY_TYPE}-${vehicleId}`,
    gate: REQUEST_VEHICLE_DOCUMENTS_BY_TYPE + vehicleId,
    path: `/customer/vehicles/${vehicleId}/documents/first-of-type/${documentType}`,
    callback,
  };
}